import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Omnigeist - Narrative Universe Platform | AI Consulting Services",
  description = "Expert AI consulting services specializing in Microsoft technologies. Transform your business with cutting-edge AI solutions.",
  keywords = "AI consulting, Microsoft technologies, digital transformation, business automation",
  ogTitle,
  ogDescription,
  canonical
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:type" content="website" />
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
};

export default SEO;

